import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getOnePermissionDetail = async (id) => {
  //   const authState = getAuthenticationState();
  try {
    if (!id) {
      return;
    }
    const resp = await apiClient.get(`/groups/showOneGroupDetail/${id}`);

    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
